<template>
  <v-container fluid class="pa-0 white" style="min-height: 100vh">
    <v-row
      v-if="carregando"
      justify="center"
      align="center"
      style="height: 60vh"
    >
      <v-progress-circular
        indeterminate
        color="#1976D2"
        size="50"
      ></v-progress-circular>
    </v-row>

    <v-row
      v-else-if="!campanha || !campanha.cupons || campanha.cupons.length === 0"
      justify="center"
      class="mt-12"
    >
      <v-col cols="12" sm="8" md="6" class="text-center pa-6">
        <v-icon size="80" color="grey lighten-2"
          >mdi-star-circle-outline</v-icon
        >
        <div class="text-h5 font-weight-black mt-4" style="color: #0d47a1">
          Construindo história
        </div>
        <div
          class="subtitle-1 grey--text text--darken-1 mt-2"
          style="line-height: 1.4"
        >
          Os cupons são uma forma de reconhecer o tempo de casa. Seus números
          aparecerão aqui nas próximas campanhas!
        </div>
      </v-col>
    </v-row>

    <div v-else>
      <v-row justify="center" class="pt-8 pb-10 px-4">
        <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
          <v-avatar
            size="72"
            style="
              background: linear-gradient(
                135deg,
                rgba(251, 192, 45, 0.2),
                rgba(255, 152, 0, 0.1)
              );
            "
          >
            <v-icon size="40" color="#FBC02D">mdi-medal-outline</v-icon>
          </v-avatar>
          <div
            class="text-h5 font-weight-black mt-4 mb-2"
            style="color: #0d47a1; letter-spacing: -0.5px"
          >
            Obrigado pela dedicação!
          </div>
          <div
            class="subtitle-1 grey--text text--darken-2"
            style="line-height: 1.4"
          >
            Para celebrar a sua trajetória aqui na cooperativa, você recebeu
            <span class="font-weight-black" style="color: #1976d2"
              >{{ campanha.cupons.length }} cupons</span
            >
            da sorte.
          </div>
          <v-btn
            v-if="campanha.regulamento"
            text
            color="#1976D2"
            class="mt-4 font-weight-bold text-none"
            :href="campanha.regulamento"
            target="_blank"
            rounded
          >
            <v-icon left size="20">mdi-file-document-outline</v-icon>
            Ler Regulamento da Promoção
          </v-btn>
        </v-col>
      </v-row>

      <div
        class="grey lighten-5 pt-8 pb-12"
        style="
          border-radius: 40px 40px 0 0;
          min-height: 50vh;
          box-shadow: 0px -5px 15px rgba(0, 0, 0, 0.03);
        "
      >
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              v-for="(item, index) in campanha.cupons"
              :key="index"
            >
              <div class="ticket-wrapper">
                <div class="ticket-stub">
                  <span>CUPOM</span>
                </div>

                <div class="ticket-divider"></div>
                <div class="ticket-notch top"></div>
                <div class="ticket-notch bottom"></div>

                <div class="ticket-body text-center">
                  <div class="ticket-number">{{ item.cupom }}</div>
                  <div class="fake-barcode">
                    <i></i><i></i><i></i><i class="thick"></i><i></i
                    ><i class="thick"></i><i></i><i></i><i></i>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "CuponsPage",
  data: () => ({
    carregando: false,
    campanha: null,
  }),
  methods: {
    async getCupons() {
      this.carregando = true;
      try {
        const res = await axios.get("/colaborador/cupons");
        // Adote a estrutura do seu JSON de retorno
        if (res.data.success) {
          this.campanha = res.data.data;
        }
      } catch (error) {
        console.error("Erro ao buscar cupons:", error);
      } finally {
        this.carregando = false;
      }
    },
  },
  mounted() {
    this.getCupons();
  },
};
</script>

<style scoped>
/* ESTILOS DO TICKET PREMIUM */
.ticket-wrapper {
  position: relative;
  display: flex;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 12px rgba(13, 71, 161, 0.06);
  border: 1px solid #f0f0f0;
  overflow: hidden;
  height: 90px;
  transition: transform 0.2s ease;
}
.ticket-wrapper:hover {
  transform: translateY(-2px);
}

.ticket-stub {
  width: 40px;
  background: linear-gradient(180deg, #2e7d32, rgba(46, 125, 50, 0.8));
  display: flex;
  align-items: center;
  justify-content: center;
}
.ticket-stub span {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 900;
  font-size: 10px;
  letter-spacing: 3px;
  transform: rotate(-90deg);
}

.ticket-divider {
  width: 1px;
  background-image: linear-gradient(
    to bottom,
    #e0e0e0 40%,
    rgba(255, 255, 255, 0) 20%
  );
  background-position: left;
  background-size: 1px 6px;
  background-repeat: repeat-y;
  position: relative;
}

.ticket-notch {
  position: absolute;
  left: 32px; /* Posicionado sobre a linha divisória */
  width: 16px;
  height: 16px;
  background-color: #fafafa; /* Cor da div grey lighten-5 */
  border-radius: 50%;
  z-index: 1;
}
.ticket-notch.top {
  top: -8px;
}
.ticket-notch.bottom {
  bottom: -8px;
}

.ticket-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ticket-number {
  font-size: 22px;
  font-weight: 900;
  color: #0d47a1;
  letter-spacing: 2px;
}

/* Falso código de barras decorativo */
.fake-barcode {
  display: flex;
  margin-top: 4px;
}
.fake-barcode i {
  display: inline-block;
  height: 6px;
  width: 1.5px;
  background-color: #e0e0e0;
  margin: 0 1.5px;
}
.fake-barcode i.thick {
  width: 3px;
}
</style>